export default function genererCritereRecherche() {
  return {
    exercice: {
      dateDebut: null,
      dateFin: null,
    },
    dateComptable: {
      dateDebut: null,
      dateFin: null,
    },
    etatLot: [],
    isValid: null,
    types: [],
    referencePiece: [],
  };
}
